import { clickOn } from "../../events/click";
import { load } from "../../events/load";

const initShopTabs = () => {
    const tabsContainer = document.querySelector('.shop-tabs');
    if (!tabsContainer) return;

    clickOn(".shop-tab", (event, trigger) => {
        event.preventDefault();

        // Skip if already active
        if (trigger.classList.contains("is-active")) return;

        // Update tab navigation state
        const tabs = document.querySelectorAll(".shop-tab");
        tabs.forEach(tab => tab.classList.remove("is-active"));
        trigger.classList.add("is-active");

        // Update tab content visibility
        const targetSlug = trigger.dataset.target;
        const allContents = document.querySelectorAll(".shop-tab-content-item");
        
        allContents.forEach(content => {
            content.classList.remove("is-active");
            if (content.id === `tab-${targetSlug}`) {
                content.classList.add("is-active");
                
                // Restart animation
                content.style.animation = 'none';
                content.offsetHeight;
                content.style.animation = null;
            }
        });
    });
};

load(initShopTabs);
